import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { swapProductWorkflow } from "./swapProductCatalog/swapProductWorkflow";

// Maps a change event workflow to the workflow that drives its steps. `GuidedWorkflow<any>`
// is the single, contained boundary where the per-workflow form shape is erased;
// each definition above keeps its concrete type, and the runner never inspects it.
export const guidedWorkflows: Record<ChangeEventWorkflow, GuidedWorkflow<any>> = {
  [ChangeEventWorkflow.SwapProduct]: swapProductWorkflow,
  [ChangeEventWorkflow.ApplyInitialConfiguration]: null as any,
  [ChangeEventWorkflow.ApplyPartialConfiguration]: null as any,
  [ChangeEventWorkflow.AddOnBookOption]: null as any,
  [ChangeEventWorkflow.ConfigurationTrueUp]: null as any,
  [ChangeEventWorkflow.FullLineCustomOption]: null as any,
};
